import anchorme from 'anchorme'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
const CryptoJS = require('crypto-js')
import { Buffer } from 'buffer'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import config from 'config'
import {
  dateDiffInDays,
  dateDiffInHours,
  dateDiffInMinutes,
  dateDiffInYears,
  dateDiffInMonths,
  dateDiffInWeeks
} from 'srcReact/helpers/datetimeHelper'
import { messengerSettings } from 'srcReact/MessengerPage/MessengerSettings'
const LRUCache = require('lrucache')

const avatarCache = LRUCache(appConstantSettings.AVATAR_CACHE_LIMIT)
const mediaCache = LRUCache(appConstantSettings.MEDIA_CACHE_LIMIT)

const emojiPattern =
  /[#*0-9]\uFE0F?\u20E3|\u00A9\uFE0F?|[\u00AE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA]\uFE0F?|[\u231A\u231B]|[\u2328\u23CF]\uFE0F?|[\u23E9-\u23EC]|[\u23ED-\u23EF]\uFE0F?|\u23F0|[\u23F1\u23F2]\uFE0F?|\u23F3|[\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC]\uFE0F?|[\u25FD\u25FE]|[\u2600-\u2604\u260E\u2611]\uFE0F?|[\u2614\u2615]|\u2618\uFE0F?|\u261D(?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?|[\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642]\uFE0F?|[\u2648-\u2653]|[\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E]\uFE0F?|\u267F|\u2692\uFE0F?|\u2693|[\u2694-\u2697\u2699\u269B\u269C\u26A0]\uFE0F?|\u26A1|\u26A7\uFE0F?|[\u26AA\u26AB]|[\u26B0\u26B1]\uFE0F?|[\u26BD\u26BE\u26C4\u26C5]|\u26C8\uFE0F?|\u26CE|[\u26CF\u26D1\u26D3]\uFE0F?|\u26D4|\u26E9\uFE0F?|\u26EA|[\u26F0\u26F1]\uFE0F?|[\u26F2\u26F3]|\u26F4\uFE0F?|\u26F5|[\u26F7\u26F8]\uFE0F?|\u26F9(?:\u200D[\u2640\u2642]\uFE0F?|\uD83C[\uDFFB-\uDFFF](?:\u200D[\u2640\u2642]\uFE0F?)?|\uFE0F(?:\u200D[\u2640\u2642]\uFE0F?)?)?|[\u26FA\u26FD]|\u2702\uFE0F?|\u2705|[\u2708\u2709]\uFE0F?|[\u270A\u270B](?:\uD83C[\uDFFB-\uDFFF])?|[\u270C\u270D](?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?|\u270F\uFE0F?|[\u2712\u2714\u2716\u271D\u2721]\uFE0F?|\u2728|[\u2733\u2734\u2744\u2747]\uFE0F?|[\u274C\u274E\u2753-\u2755\u2757]|\u2763\uFE0F?|\u2764(?:\u200D(?:\uD83D\uDD25|\uD83E\uDE79)|\uFE0F(?:\u200D(?:\uD83D\uDD25|\uD83E\uDE79))?)?|[\u2795-\u2797]|\u27A1\uFE0F?|[\u27B0\u27BF]|[\u2934\u2935\u2B05-\u2B07]\uFE0F?|[\u2B1B\u2B1C\u2B50\u2B55]|[\u3030\u303D\u3297\u3299]\uFE0F?|\uD83C(?:[\uDC04\uDCCF]|[\uDD70\uDD71\uDD7E\uDD7F]\uFE0F?|[\uDD8E\uDD91-\uDD9A]|\uDDE6\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF]|\uDDE7\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF]|\uDDE8\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF]|\uDDE9\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF]|\uDDEA\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA]|\uDDEB\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7]|\uDDEC\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE]|\uDDED\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA]|\uDDEE\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9]|\uDDEF\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5]|\uDDF0\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF]|\uDDF1\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE]|\uDDF2\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF]|\uDDF3\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF]|\uDDF4\uD83C\uDDF2|\uDDF5\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE]|\uDDF6\uD83C\uDDE6|\uDDF7\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC]|\uDDF8\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF]|\uDDF9\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF]|\uDDFA\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF]|\uDDFB\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA]|\uDDFC\uD83C[\uDDEB\uDDF8]|\uDDFD\uD83C\uDDF0|\uDDFE\uD83C[\uDDEA\uDDF9]|\uDDFF\uD83C[\uDDE6\uDDF2\uDDFC]|\uDE01|\uDE02\uFE0F?|[\uDE1A\uDE2F\uDE32-\uDE36]|\uDE37\uFE0F?|[\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20]|[\uDF21\uDF24-\uDF2C]\uFE0F?|[\uDF2D-\uDF35]|\uDF36\uFE0F?|[\uDF37-\uDF7C]|\uDF7D\uFE0F?|[\uDF7E-\uDF84]|\uDF85(?:\uD83C[\uDFFB-\uDFFF])?|[\uDF86-\uDF93]|[\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F]\uFE0F?|[\uDFA0-\uDFC1]|\uDFC2(?:\uD83C[\uDFFB-\uDFFF])?|[\uDFC3\uDFC4](?:\u200D[\u2640\u2642]\uFE0F?|\uD83C[\uDFFB-\uDFFF](?:\u200D[\u2640\u2642]\uFE0F?)?)?|[\uDFC5\uDFC6]|\uDFC7(?:\uD83C[\uDFFB-\uDFFF])?|[\uDFC8\uDFC9]|\uDFCA(?:\u200D[\u2640\u2642]\uFE0F?|\uD83C[\uDFFB-\uDFFF](?:\u200D[\u2640\u2642]\uFE0F?)?)?|[\uDFCB\uDFCC](?:\u200D[\u2640\u2642]\uFE0F?|\uD83C[\uDFFB-\uDFFF](?:\u200D[\u2640\u2642]\uFE0F?)?|\uFE0F(?:\u200D[\u2640\u2642]\uFE0F?)?)?|[\uDFCD\uDFCE]\uFE0F?|[\uDFCF-\uDFD3]|[\uDFD4-\uDFDF]\uFE0F?|[\uDFE0-\uDFF0]|\uDFF3(?:\u200D(?:\u26A7\uFE0F?|\uD83C\uDF08)|\uFE0F(?:\u200D(?:\u26A7\uFE0F?|\uD83C\uDF08))?)?|\uDFF4(?:\u200D\u2620\uFE0F?|\uDB40\uDC67\uDB40\uDC62\uDB40(?:\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDC73\uDB40\uDC63\uDB40\uDC74|\uDC77\uDB40\uDC6C\uDB40\uDC73)\uDB40\uDC7F)?|[\uDFF5\uDFF7]\uFE0F?|[\uDFF8-\uDFFF])|\uD83D(?:[\uDC00-\uDC07]|\uDC08(?:\u200D\u2B1B)?|[\uDC09-\uDC14]|\uDC15(?:\u200D\uD83E\uDDBA)?|[\uDC16-\uDC3A]|\uDC3B(?:\u200D\u2744\uFE0F?)?|[\uDC3C-\uDC3E]|\uDC3F\uFE0F?|\uDC40|\uDC41(?:\u200D\uD83D\uDDE8\uFE0F?|\uFE0F(?:\u200D\uD83D\uDDE8\uFE0F?)?)?|[\uDC42\uDC43](?:\uD83C[\uDFFB-\uDFFF])?|[\uDC44\uDC45]|[\uDC46-\uDC50](?:\uD83C[\uDFFB-\uDFFF])?|[\uDC51-\uDC65]|[\uDC66\uDC67](?:\uD83C[\uDFFB-\uDFFF])?|\uDC68(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?|[\uDC68\uDC69]\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92])|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFC-\uDFFF]|[\uDDAF-\uDDB3\uDDBC\uDDBD])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFD-\uDFFF]|[\uDDAF-\uDDB3\uDDBC\uDDBD])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|[\uDDAF-\uDDB3\uDDBC\uDDBD])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFD\uDFFF]|[\uDDAF-\uDDB3\uDDBC\uDDBD])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFE]|[\uDDAF-\uDDB3\uDDBC\uDDBD])))?))?|\uDC69(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?[\uDC68\uDC69]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?|\uDC69\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92])|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFF]|\uDC8B\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFC-\uDFFF]|[\uDDAF-\uDDB3\uDDBC\uDDBD])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFF]|\uDC8B\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFD-\uDFFF]|[\uDDAF-\uDDB3\uDDBC\uDDBD])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFF]|\uDC8B\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|[\uDDAF-\uDDB3\uDDBC\uDDBD])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFF]|\uDC8B\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFD\uDFFF]|[\uDDAF-\uDDB3\uDDBC\uDDBD])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFF]|\uDC8B\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFE]|[\uDDAF-\uDDB3\uDDBC\uDDBD])))?))?|\uDC6A|[\uDC6B-\uDC6D](?:\uD83C[\uDFFB-\uDFFF])?|\uDC6E(?:\u200D[\u2640\u2642]\uFE0F?|\uD83C[\uDFFB-\uDFFF](?:\u200D[\u2640\u2642]\uFE0F?)?)?|\uDC6F(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDC70\uDC71](?:\u200D[\u2640\u2642]\uFE0F?|\uD83C[\uDFFB-\uDFFF](?:\u200D[\u2640\u2642]\uFE0F?)?)?|\uDC72(?:\uD83C[\uDFFB-\uDFFF])?|\uDC73(?:\u200D[\u2640\u2642]\uFE0F?|\uD83C[\uDFFB-\uDFFF](?:\u200D[\u2640\u2642]\uFE0F?)?)?|[\uDC74-\uDC76](?:\uD83C[\uDFFB-\uDFFF])?|\uDC77(?:\u200D[\u2640\u2642]\uFE0F?|\uD83C[\uDFFB-\uDFFF](?:\u200D[\u2640\u2642]\uFE0F?)?)?|\uDC78(?:\uD83C[\uDFFB-\uDFFF])?|[\uDC79-\uDC7B]|\uDC7C(?:\uD83C[\uDFFB-\uDFFF])?|[\uDC7D-\uDC80]|[\uDC81\uDC82](?:\u200D[\u2640\u2642]\uFE0F?|\uD83C[\uDFFB-\uDFFF](?:\u200D[\u2640\u2642]\uFE0F?)?)?|\uDC83(?:\uD83C[\uDFFB-\uDFFF])?|\uDC84|\uDC85(?:\uD83C[\uDFFB-\uDFFF])?|[\uDC86\uDC87](?:\u200D[\u2640\u2642]\uFE0F?|\uD83C[\uDFFB-\uDFFF](?:\u200D[\u2640\u2642]\uFE0F?)?)?|[\uDC88-\uDC8E]|\uDC8F(?:\uD83C[\uDFFB-\uDFFF])?|\uDC90|\uDC91(?:\uD83C[\uDFFB-\uDFFF])?|[\uDC92-\uDCA9]|\uDCAA(?:\uD83C[\uDFFB-\uDFFF])?|[\uDCAB-\uDCFC]|\uDCFD\uFE0F?|[\uDCFF-\uDD3D]|[\uDD49\uDD4A]\uFE0F?|[\uDD4B-\uDD4E\uDD50-\uDD67]|[\uDD6F\uDD70\uDD73]\uFE0F?|\uDD74(?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?|\uDD75(?:\u200D[\u2640\u2642]\uFE0F?|\uD83C[\uDFFB-\uDFFF](?:\u200D[\u2640\u2642]\uFE0F?)?|\uFE0F(?:\u200D[\u2640\u2642]\uFE0F?)?)?|[\uDD76-\uDD79]\uFE0F?|\uDD7A(?:\uD83C[\uDFFB-\uDFFF])?|[\uDD87\uDD8A-\uDD8D]\uFE0F?|\uDD90(?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?|[\uDD95\uDD96](?:\uD83C[\uDFFB-\uDFFF])?|\uDDA4|[\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA]\uFE0F?|[\uDDFB-\uDE2D]|\uDE2E(?:\u200D\uD83D\uDCA8)?|[\uDE2F-\uDE34]|\uDE35(?:\u200D\uD83D\uDCAB)?|\uDE36(?:\u200D\uD83C\uDF2B\uFE0F?)?|[\uDE37-\uDE44]|[\uDE45-\uDE47](?:\u200D[\u2640\u2642]\uFE0F?|\uD83C[\uDFFB-\uDFFF](?:\u200D[\u2640\u2642]\uFE0F?)?)?|[\uDE48-\uDE4A]|\uDE4B(?:\u200D[\u2640\u2642]\uFE0F?|\uD83C[\uDFFB-\uDFFF](?:\u200D[\u2640\u2642]\uFE0F?)?)?|\uDE4C(?:\uD83C[\uDFFB-\uDFFF])?|[\uDE4D\uDE4E](?:\u200D[\u2640\u2642]\uFE0F?|\uD83C[\uDFFB-\uDFFF](?:\u200D[\u2640\u2642]\uFE0F?)?)?|\uDE4F(?:\uD83C[\uDFFB-\uDFFF])?|[\uDE80-\uDEA2]|\uDEA3(?:\u200D[\u2640\u2642]\uFE0F?|\uD83C[\uDFFB-\uDFFF](?:\u200D[\u2640\u2642]\uFE0F?)?)?|[\uDEA4-\uDEB3]|[\uDEB4-\uDEB6](?:\u200D[\u2640\u2642]\uFE0F?|\uD83C[\uDFFB-\uDFFF](?:\u200D[\u2640\u2642]\uFE0F?)?)?|[\uDEB7-\uDEBF]|\uDEC0(?:\uD83C[\uDFFB-\uDFFF])?|[\uDEC1-\uDEC5]|\uDECB\uFE0F?|\uDECC(?:\uD83C[\uDFFB-\uDFFF])?|[\uDECD-\uDECF]\uFE0F?|[\uDED0-\uDED2\uDED5-\uDED7\uDEDD-\uDEDF]|[\uDEE0-\uDEE5\uDEE9]\uFE0F?|[\uDEEB\uDEEC]|[\uDEF0\uDEF3]\uFE0F?|[\uDEF4-\uDEFC\uDFE0-\uDFEB\uDFF0])|\uD83E(?:\uDD0C(?:\uD83C[\uDFFB-\uDFFF])?|[\uDD0D\uDD0E]|\uDD0F(?:\uD83C[\uDFFB-\uDFFF])?|[\uDD10-\uDD17]|[\uDD18-\uDD1F](?:\uD83C[\uDFFB-\uDFFF])?|[\uDD20-\uDD25]|\uDD26(?:\u200D[\u2640\u2642]\uFE0F?|\uD83C[\uDFFB-\uDFFF](?:\u200D[\u2640\u2642]\uFE0F?)?)?|[\uDD27-\uDD2F]|[\uDD30-\uDD34](?:\uD83C[\uDFFB-\uDFFF])?|\uDD35(?:\u200D[\u2640\u2642]\uFE0F?|\uD83C[\uDFFB-\uDFFF](?:\u200D[\u2640\u2642]\uFE0F?)?)?|\uDD36(?:\uD83C[\uDFFB-\uDFFF])?|[\uDD37-\uDD39](?:\u200D[\u2640\u2642]\uFE0F?|\uD83C[\uDFFB-\uDFFF](?:\u200D[\u2640\u2642]\uFE0F?)?)?|\uDD3A|\uDD3C(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD3D\uDD3E](?:\u200D[\u2640\u2642]\uFE0F?|\uD83C[\uDFFB-\uDFFF](?:\u200D[\u2640\u2642]\uFE0F?)?)?|[\uDD3F-\uDD45\uDD47-\uDD76]|\uDD77(?:\uD83C[\uDFFB-\uDFFF])?|[\uDD78-\uDDB4]|[\uDDB5\uDDB6](?:\uD83C[\uDFFB-\uDFFF])?|\uDDB7|[\uDDB8\uDDB9](?:\u200D[\u2640\u2642]\uFE0F?|\uD83C[\uDFFB-\uDFFF](?:\u200D[\u2640\u2642]\uFE0F?)?)?|\uDDBA|\uDDBB(?:\uD83C[\uDFFB-\uDFFF])?|[\uDDBC-\uDDCC]|[\uDDCD-\uDDCF](?:\u200D[\u2640\u2642]\uFE0F?|\uD83C[\uDFFB-\uDFFF](?:\u200D[\u2640\u2642]\uFE0F?)?)?|\uDDD0|\uDDD1(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:\uDD1D\u200D\uD83E\uDDD1|[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFC-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF]|[\uDDAF-\uDDB3\uDDBC\uDDBD])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFD-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF]|[\uDDAF-\uDDB3\uDDBC\uDDBD])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF]|[\uDDAF-\uDDB3\uDDBC\uDDBD])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFD\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF]|[\uDDAF-\uDDB3\uDDBC\uDDBD])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFE]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF]|[\uDDAF-\uDDB3\uDDBC\uDDBD])))?))?|[\uDDD2\uDDD3](?:\uD83C[\uDFFB-\uDFFF])?|\uDDD4(?:\u200D[\u2640\u2642]\uFE0F?|\uD83C[\uDFFB-\uDFFF](?:\u200D[\u2640\u2642]\uFE0F?)?)?|\uDDD5(?:\uD83C[\uDFFB-\uDFFF])?|[\uDDD6-\uDDDD](?:\u200D[\u2640\u2642]\uFE0F?|\uD83C[\uDFFB-\uDFFF](?:\u200D[\u2640\u2642]\uFE0F?)?)?|[\uDDDE\uDDDF](?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDDE0-\uDDFF\uDE70-\uDE74\uDE78-\uDE7C\uDE80-\uDE86\uDE90-\uDEAC\uDEB0-\uDEBA\uDEC0-\uDEC2]|[\uDEC3-\uDEC5](?:\uD83C[\uDFFB-\uDFFF])?|[\uDED0-\uDED9\uDEE0-\uDEE7]|\uDEF0(?:\uD83C[\uDFFB-\uDFFF])?|\uDEF1(?:\uD83C(?:\uDFFB(?:\u200D\uD83E\uDEF2\uD83C[\uDFFC-\uDFFF])?|\uDFFC(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFD-\uDFFF])?|\uDFFD(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])?|\uDFFE(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFD\uDFFF])?|\uDFFF(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFE])?))?|[\uDEF2-\uDEF6](?:\uD83C[\uDFFB-\uDFFF])?)/g

export const resetClass = (element, className) => {
  const { classList } = element
  while (classList.length > 0) {
    classList.remove(classList.item(0))
  }
  if (className && className != '') {
    classList.add(className)
  }
}

export const encode_utf8 = (s) => {
  return encodeURIComponent(s)
}

export const decode_utf8 = (s) => {
  return decodeURIComponent(s)
}

export const getCookie = (cname) => {
  const v = document.cookie.match(`(^|;) ?${cname}=([^;]*)(;|$)`)
  return v ? v[2] : null
}

export const setCookie = (cname, cvalue, exdays) => {
  const d = new Date()
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  const expires = `expires=${d.toUTCString()}`
  document.cookie = `${cname}=${cvalue};${expires};path=/;secure`
}

export const setCookieForNativeApp = ({ performance, functional, marketing }) => {
  window.location = `${config.webUrl}/0/gdpr/cookie/enabled?performance=${performance}&functional=${functional}&marketing=${marketing}`
}

export const cleanAllCookie = (excludeCookies) => {
  const allCookieArray = document.cookie.split(';')
  for (let i = 0; i < allCookieArray.length; i++) {
    if (excludeCookies.length > 0) {
      for (let j = 0; j < excludeCookies.length; j++) {
        const key = allCookieArray[i].split('=')[0].trim()
        if (key !== excludeCookies[j].trim()) {
          const cname = allCookieArray[i].trim()
          setCookie(cname, false, -1)
        }
      }
    } else {
      const cname = allCookieArray[i].trim()
      setCookie(cname, false, -1)
    }
  }
}

export const cleanData = (redirect) => {
  localStorage.removeItem('user_id')
  localStorage.removeItem('ssoOrgId')
  localStorage.removeItem('ssoOrgList')
  localStorage.removeItem('mixrOrgId')
  localStorage.removeItem('request_to_delete')
  localStorage.removeItem('user')
  localStorage.removeItem('active_popup_global')
  localStorage.removeItem('current_organization')
  localStorage.removeItem('organization_list')
  cleanAllCookie(['gdpr'])
  if (redirect) {
    // window.location = config.webUrl + '/communities-at-work'
    window.location = 'https://community.mixr.net/'
  }
}

export const objectMap = (obj, fn, array) => {
  const newObject = Object.fromEntries(Object.entries(obj).map(([k, v], i) => [k, fn(v, k, i)]))

  if (array == true) {
    return valuesToArray(newObject)
  }

  return newObject
}

export const deepEqual = (obj1, obj2) => {
  if (obj1 === obj2)
    // it's just the same object. No need to compare.
    return true

  if (isPrimitive(obj1) && isPrimitive(obj2))
    // compare primitives
    return obj1 === obj2

  if (Object.keys(obj1).length !== Object.keys(obj2).length) return false

  // compare objects with same number of keys
  for (let key in obj1) {
    if (!(key in obj2)) return false //other object doesn't have this prop
    if (!deepEqual(obj1[key], obj2[key])) return false
  }

  return true
}

//check if value is primitive
export const isPrimitive = (obj) => {
  return obj !== Object(obj)
}

export const valuesToArray = (obj) => {
  return Object.keys(obj).map(function (key) {
    return obj[key]
  })
}

export const isIOS = () => {
  return !!/iPhone|iPad|iPod/i.test(navigator.userAgent)
}

export const isAndroid = () => {
  return !!/Android/i.test(navigator.userAgent)
}

export const isNativeIOS = () => {
  return urlSearchParams('native_os') === 'ios'
}

export const isNativeAndroid = () => {
  return urlSearchParams('native_os') === 'android'
}

export const addScript = (id, src) => {
  return new Promise((resolve, reject) => {
    const element = document.getElementById(id)
    if (element) {
      return resolve(true)
    }

    const script = document.createElement('script')
    script.setAttribute('type', 'text/javascript')
    script.setAttribute('id', id)
    script.setAttribute('src', src)
    script.addEventListener('load', resolve)
    script.addEventListener('error', () => reject(new Error(`Error loading ${id}.`)))
    script.addEventListener('abort', () => reject(new Error(`${id}  loading aborted.`)))
    document.body.appendChild(script)
  })
}

export const injectScript = (id, src) => {
  if (document.getElementById(id)) return

  const script = document.createElement('script')

  script.id = id
  script.type = 'text/javascript'
  script.src = src

  document.body.appendChild(script)
}

export const removeScript = (id) => {
  const script = document.getElementById(id)
  if (script) {
    document.body.removeChild(script)
  }
}

export const truncateWithEllipses = (text, max) => {
  return text.substr(0, max - 1) + (text.length > max ? '...' : '')
}

export const truncateHTMLWithEllipses = (html, max) => {
  const parser = new DOMParser()
  const doc = parser.parseFromString(html, 'text/html')

  const truncateText = (node, maxLength) => {
    if (node.nodeType === Node.TEXT_NODE) {
      if (node.textContent.length > maxLength) {
        node.textContent = node.textContent.substr(0, maxLength - 1) + '...'
      }
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      node.childNodes.forEach((childNode) => {
        truncateText(childNode, maxLength)
      })
    }
  }

  truncateText(doc.body, max)

  const serializer = new XMLSerializer()
  return serializer.serializeToString(doc)
}

export const isCharacterCounter = (text, num) => {
  return text.length >= num ? true : false
}

export const getInitials = (text) => {
  if (typeof text !== 'undefined') {
    const array = text.split(' ')
    let initials

    if (array.length <= 4) {
      initials = array.map((initial) => initial[0])
    } else {
      initials = array.map((initial, index) => {
        if (index < 3) {
          return initial[0]
        }
      })
      initials.push(array[array.length - 1][0])
    }

    return initials.join('').toUpperCase()
  }
}

export const capitalize = (text = '') => {
  return text.toLowerCase().replace(/\b\w/g, function (m) {
    return m.toUpperCase()
  })
}

export const ucfirst = (text) => {
  return text.charAt(0).toUpperCase() + text.slice(1)
}

export const randomValue = (array) => {
  const index = randomBetween(0, array.length - 1)
  return array[index]
}

export const randomBetween = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1)) + min
}

export const commonProperties = (o1, o2) => {
  return Object.entries(o1)
    .filter(function (itm) {
      return itm[0] in o2
    })
    .map((obj) => {
      return { id: obj[0], name: obj[1] }
    })
}

export const encodeBase64 = (string) => {
  return btoa(string).replace(/\+\//, '-_')
}

export const uuid = () => {
  let uUid = ''
  let i
  let random
  for (i = 0; i < 32; i++) {
    random = (Math.random() * 16) | 0

    if (i == 8 || i == 12 || i == 16 || i == 20) {
      uUid += '-'
    }
    uUid += (i == 12 ? 4 : i == 16 ? (random & 3) | 8 : random).toString(16)
  }
  return uUid
}

export const getMq = () => {
  if (window.innerWidth < 720) {
    return 'mobile'
  }
  if (window.innerWidth >= 720 && window.innerWidth < 1160) {
    return 'tablet'
  }
  return 'desktop'
  // return window
  //   .getComputedStyle(document.querySelector('body'), '::before')
  //   .getPropertyValue('content')
  //   .replace(/\"/g, '') // eslint-disable-line no-useless-escape
}

export const isPortrait = () => {
  const mq = getMq()
  return mq === 'mobile' && window.orientation === 0
}

export const isWideScreen = () => {
  return getMq() === 'desktop'
}

export const isTabletScreen = () => {
  return getMq() === 'tablet'
}

export const isMobileScreen = () => {
  return (isNative() && getMq() === 'mobile') || getMq() === 'mobile'
}

export const isHDScreen = () => {
  if (window.innerWidth >= 1360) {
    return true
  }
  return false
}

export const isHDPlusScreen = () => {
  if (window.innerWidth >= 1600) {
    return true
  }
  return false
}

export const isFullHDScreen = () => {
  if (window.innerWidth >= 1920) {
    return true
  }
  return false
}

export const isNative = () => {
  const urlParams = new URLSearchParams(window.location.search)
  let cookieNative = (document.cookie.match('(^|;) ?native_app=([^;]*)(;|$)') || 0)[2] || urlParams.get('native_app')
  if (cookieNative) {
    setCookie('native_app', 1, 365)
    return cookieNative
  }
  return false
}

export const urlSearchParams = (param) => {
  const urlParams = new URLSearchParams(window.location.search)
  let cookieSearchParams = urlParams.get(param) || (document.cookie.match(`(^|;) ?${param}=([^;]*)(;|$)`) || 0)[2]
  if (cookieSearchParams) {
    setCookie(param, cookieSearchParams, 365)
    return cookieSearchParams
  }
  return false
}

export const redirectInternalError = (history, data) => {
  return history.push({
    pathname: '/0/internal-error',
    state: { detail: data }
  })
}

export const dissoc = (key, obj) => {
  let copy = Object.assign({}, obj)
  delete copy[key]
  return copy
}

export const isNum = (val) => {
  return !isNaN(val)
}

export function anchorMe(inputText) {
  const result = anchorme({
    input: inputText,
    options: {
      attributes: {
        target: '_blank'
      },
      // Emails & files will be excluded
      exclude: function (string) {
        if (anchorme.validate.email(string)) {
          return true
        } else if (string.startsWith('file:///')) {
          return true
        } else {
          return false
        }
      }
    }
  })
  // const exp_match = /(\b(https?|):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi
  // const element_content = text.replace(exp_match, '<a target="_blank" href="$1">$1</a>')
  // console.log('element_content is:', element_content)
  return result
}

export function generateGreetings() {
  var currentHour = dayjs().format('HH')
  const { t } = useTranslation()

  if (currentHour >= 0 && currentHour < 12) {
    return t('welcomeBanner.gm')
  } else if (currentHour >= 12 && currentHour < 17) {
    return t('welcomeBanner.ga')
  } else if (currentHour >= 17 && currentHour < 24) {
    return t('welcomeBanner.ge')
  }
}

export function dataURLtoFile(dataurl, filename) {
  var arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n)

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }

  return new File([u8arr], filename, { type: mime })
}

export async function getDescryptedMedia(encryptedUrl, isOriginal, originalTag, mimeType, id = null, isAvatar = false) {
  if (isOriginal === 1 || !originalTag) {
    if (id) {
      return { img: encryptedUrl, id }
    } else {
      return encryptedUrl
    }
  } else {
    try {
      //compare the url also in case if user has updated the profile picture
      if (isAvatar && avatarCache?.has(id) && avatarCache?.get(id).url === encryptedUrl) {
        return avatarCache.get(id).decryptedImage
      }
      if (!isAvatar && mediaCache?.has(id)) {
        return mediaCache.get(id)
      }

      const response = await fetch(`${encryptedUrl}`)
      const data = await response.text()
      const objJson = JSON.parse(data)
      const encrypted = objJson.ciphertext
      const salt = CryptoJS.enc.Hex.parse(objJson.salt)
      const iv = CryptoJS.enc.Hex.parse(objJson.iv)
      const key = CryptoJS.PBKDF2(originalTag, salt, {
        hasher: CryptoJS.algo.SHA512,
        keySize: 64 / 8,
        iterations: 999
      })

      // Chunked decryption to handle large files more efficiently on mobile devices
      const chunkSize = 1024 * 1024 // 1MB chunk size
      let decryptedData = ''

      for (let i = 0; i < encrypted.length; i += chunkSize) {
        const chunk = encrypted.slice(i, i + chunkSize)
        const decryptedChunk = CryptoJS.AES.decrypt(chunk, key, { iv: iv }).toString(CryptoJS.enc.Hex)
        decryptedData += decryptedChunk
      }

      const base64Image = Buffer.from(decryptedData, 'hex').toString('base64')
      let mime = 'image/jpg'
      if (mimeType) {
        mime = mimeType
      }
      if (id) {
        const imageObj = { img: `data:${mime};base64,${base64Image}`, id }
        if (isAvatar) {
          avatarCache.set(id, { decryptedImage: imageObj, url: encryptedUrl })
        } else {
          mediaCache.set(id, imageObj)
        }
        return imageObj
      } else {
        const imageStr = `data:${mime};base64,${base64Image}`
        if (isAvatar) {
          avatarCache.set(id, { decryptedImage: imageStr, url: encryptedUrl })
        } else {
          mediaCache.set(id, imageStr)
        }
        return imageStr
      }
    } catch (e) {
      return ''
    }
  }
}

export async function getNativeDecryptedMedia(
  s3Url,
  encryptedUrl,
  isOriginal,
  originalTag,
  mimeType,
  filename,
  action = 'download'
) {
  if (action === 'open' && (isOriginal == 1 || !originalTag)) {
    return (window.location = `${config.webUrl + `/decrypted/media/open?data=${s3Url}&action=${action}`}`)
  } else if (isOriginal == 1 || !originalTag) {
    return (window.location = s3Url)
  } else {
    return (window.location = `${
      config.webUrl +
      `/decrypted/media/download?data=${encryptedUrl}&mime=${mimeType}&name=${filename}&action=${action}`
    }`)
  }
}

const getStringFromByteArray = (bytes) => {
  let str = ''
  for (let i = 0; i < bytes.length; i++) {
    str += String.fromCharCode(bytes[i])
  }

  return str
}
export const isPasswordComplex = (password) => {
  const minMaxLength = /^[\s\S]{8,15}$/
  const upper = /[A-Z]/
  const lower = /[a-z]/
  const number = /[0-9]/
  const special = /[#@&!\?\*\$%\+\-_\.;/:,=]/

  if (
    minMaxLength.test(password) &&
    upper.test(password) &&
    lower.test(password) &&
    number.test(password) &&
    special.test(password)
  ) {
    return true
  }
  return false
}

export const validateURL = (link) => {
  if (link.indexOf('http://') == 0 || link.indexOf('https://') == 0) {
    return link
  } else {
    return `https://${link}`
  }
}

export const openInNewTab = (url) => {
  const finalURL = validateURL(url)
  if (isNative()) return (window.location.href = finalURL)
  const newWindow = window.open(finalURL, '_blank', 'noopener,noreferrer')
  if (newWindow) newWindow.opener = null
}

export const popupWindow = (url, title, w, h) => {
  // Fixes dual-screen position                             Most browsers      Firefox
  const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX
  const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY

  const width = window.innerWidth
    ? window.innerWidth
    : document.documentElement.clientWidth
    ? document.documentElement.clientWidth
    : screen.width
  const height = window.innerHeight
    ? window.innerHeight
    : document.documentElement.clientHeight
    ? document.documentElement.clientHeight
    : screen.height

  const systemZoom = width / window.screen.availWidth
  const left = (width - w) / 2 / systemZoom + dualScreenLeft
  const top = (height - h) / 2 / systemZoom + dualScreenTop

  const newWindow = window.open(
    url,
    title,
    `
     scrollbars=yes,
     width=${w / systemZoom}, 
     height=${h / systemZoom}, 
     top=${top}, 
     left=${left}
     `
  )

  if (window?.focus) newWindow?.focus()
  return newWindow
}

export const chunkArrayInGroups = (arr, size) => {
  var myArray = []
  for (var i = 0; i < arr.length; i += size) {
    myArray.push(arr.slice(i, i + size))
  }
  return myArray
}

//html = the whole html string in which search needs to be done
//string = search text
//contextWordCount = define how many characters before and after the search term should be included in the match.
//The value 3 ( in contextWordCount * 3 ) is chosen based on the assumption that the average word length, including spaces and punctuation, is about 3 characters. This is a simplification and may not be accurate for all texts, but it provides a rough estimate.
export const getContentWithHighlightedText = (html, string = '', contextWordCount = 10) => {
  if (string.length >= 1) {
    const searchText = new RegExp(string, 'gi')
    const plainText = convertToPlain(html)
    const regex = new RegExp(`(.{0,${contextWordCount * 3}}${string}.{0,${contextWordCount * 3}})`, 'gi')
    const match = regex.exec(plainText)
    if (match) {
      const matchWithHighLight = match[0].replace(searchText, `<span class='highlighted' role="presentation">$&</span>`)
      return matchWithHighLight
    }
  }
  return html
}

export const getHighlightedSearchContent = (content, string = '') => {
  if (string.length >= 1) {
    if (!content.toLowerCase().includes(string.toLowerCase())) {
      return `<span class='highlightedSearch' role='presentation'>${string}</span>`
    }
  }
  return ''
}

export const getMemberNames = (members, conversationName, t) => {
  let conversationLable = ''
  if (conversationName) {
    conversationLable = conversationName
  } else {
    if (members.length === 1) {
      conversationLable = members[0].firstname + ' ' + members[0].lastname
    } else if (members.length === 2) {
      conversationLable = members
        .map((member) => {
          if (member.is_logged_user) {
            return
          }
          return member.firstname + ' ' + member.lastname
        })
        .join(' & ')
    } else if (members.length === 3) {
      const updatedName = members.reduce((prevVal, member, index) => {
        const lastChar = index === 0 ? ', ' : index === 1 ? ' & ' : ''
        return `${prevVal} ${member.firstname} ${
          member.lastname ? `${member.lastname.charAt(0).toUpperCase()}.${lastChar}` : lastChar
        }`
      }, '')
      conversationLable = updatedName
    } else {
      const diplayNameCount = isMobileScreen() ? 2 : isTabletScreen() ? 4 : 6
      const remainingCount = members.length - diplayNameCount
      conversationLable = members
        .filter((member, index) => index < diplayNameCount)
        .map((member) => {
          return `${member.firstname} ${member.lastname ? `${member.lastname.charAt(0).toUpperCase()}.` : ''}`
        })
        .join(', ')
      if (remainingCount > 0) {
        if (remainingCount === 1) {
          conversationLable = t('messenger.header.conversationMembersLabel1More', {
            conversationLabel: conversationLable,
            remainingCount
          })
        } else {
          conversationLable = t('messenger.header.conversationMembersLabelOthers', {
            conversationLabel: conversationLable,
            remainingCount
          })
        }
      }
    }
  }
  return conversationLable
}

export const getCurrentLanguageFromCookie = () => {
  let lang = appConstantSettings.DEFAULT_LANGUAGE
  if (config.enableTranslation) {
    lang = getCookie(appConstantSettings.LANG_COOKIE_NAME) || appConstantSettings.DEFAULT_LANGUAGE
  }
  if (lang.length > 2) {
    lang = lang.split('-')[0] // this splitting is if language in form of en-GB
  }
  if (isNative()) {
    lang = urlSearchParams(appConstantSettings.LANG_COOKIE_NAME) || appConstantSettings.DEFAULT_LANGUAGE
  }
  return lang
}

export const getEmojiFromCode = (emojiCode) => {
  const emoji = emojiCode
    .split('-')
    .map((codePoint) => {
      if (codePoint) {
        return String.fromCodePoint(parseInt(codePoint, 16))
      }
    })
    .join('')
  return emoji
}

export const getFlagEmoji = (countryCode) => {
  let emoji = ''
  switch (countryCode) {
    case 'en': {
      emoji = getEmojiFromCode('1f1fa-1f1f2')
      break
    }
    case 'fr': {
      emoji = getEmojiFromCode('1f1eb-1f1f7')
      break
    }
  }
  return emoji
}

export const delay = (t) => new Promise((resolve) => setTimeout(resolve, t))

export const getOrganizationAccronym = (orgName) => {
  let accronym = ''
  let matches = orgName.match(/\b(\w)/gi)
  if (matches != null) {
    if (orgName.split(' ').length > 3) {
      accronym = matches.join('').slice(0, 4).toUpperCase()
    } else {
      accronym = matches.join('').slice(0, orgName.split(' ').length).toUpperCase()
    }
  }
  return accronym
}

export const getColorHexCode = (name) => {
  const color = appConstantSettings.COLORS.find((c) => c.name === name)
  return color && color.hex
}

export const getWorkplaceRoleColor = (roles) => {
  let role = roles.split(`, `)[0]
  const color = appConstantSettings.WORKPLACE_ROLES_COLORS.find((r) => r.role === role)
  return color ? color.hex : appConstantSettings.WORKPLACE_ROLES_COLORS[0].hex
}

export const getWorkplaceInviteSent = (t, date) => {
  const minutesAgo = dateDiffInMinutes(new Date(), date)
  const hoursAgo = dateDiffInHours(new Date(), date)
  const daysAgo = dateDiffInDays(new Date(), date)
  const weeksAgo = dateDiffInWeeks(new Date(), date)
  const monthsAgo = dateDiffInMonths(new Date(), date)
  const yearsAgo = dateDiffInYears(new Date(), date)
  if (minutesAgo < 60) {
    return `${t('global.minuteAgo_plural', { count: Math.floor(minutesAgo) })}`
  } else if (hoursAgo < 24) {
    return `${t('global.hourAgo_plural', { count: Math.floor(hoursAgo) })}`
  } else if (daysAgo < 7) {
    return `${t('global.dayAgo_plural', { count: Math.floor(daysAgo) })}`
  } else if (weeksAgo < 4) {
    return `${t('global.hourAgo_plural', { count: Math.floor(weeksAgo) })}`
  } else if (monthsAgo < 12) {
    return `${t('global.monthAgo_plural', { count: Math.floor(monthsAgo) })}`
  } else {
    return `${t('global.yearAgo_plural', { count: Math.floor(yearsAgo) })}`
  }
}

export const getWorkplaceMemberSince = (date) => {
  const minutesAgo = dateDiffInMinutes(new Date(), date)
  const hoursAgo = dateDiffInHours(new Date(), date)
  const daysAgo = dateDiffInDays(new Date(), date)
  const weeksAgo = dateDiffInWeeks(new Date(), date)
  const monthsAgo = dateDiffInMonths(new Date(), date)
  const yearsAgo = dateDiffInYears(new Date(), date)
  if (minutesAgo < 60) {
    return `${Math.floor(minutesAgo)}m`
  } else if (hoursAgo < 24) {
    return `${Math.floor(hoursAgo)}h`
  } else if (daysAgo < 7) {
    return `${Math.floor(daysAgo)}d`
  } else if (weeksAgo < 4) {
    return `${Math.floor(weeksAgo)}w`
  } else if (monthsAgo < 12) {
    return `${Math.floor(monthsAgo)}m`
  } else {
    return `${Math.floor(yearsAgo)}y`
  }
  // if (dateDiff === 0) return `< 1y`
  // return `${dateDiff} y`
}

export const getConvertCentToDollar = (amount, currency) => {
  return (amount / 100).toLocaleString('en-US', { style: 'currency', currency: currency })
}

export const getIconNameFromExtension = (extension) => {
  if (extension === 'pdf') {
    return 'pdf'
  }
  if (extension === 'doc' || extension === 'docx') {
    return 'doc'
  }
  if (extension === 'xls' || extension === 'xlsx') {
    return 'xls'
  }
  if (extension === 'ppt' || extension === 'pptx') {
    return 'ppt'
  }
  if (messengerSettings.ACCEPTED_ZIP_TYPES && messengerSettings.ACCEPTED_ZIP_TYPES.split(',').includes(extension)) {
    return 'zip'
  }
}

export const getFlaggedColor = (count) => {
  if (count > 1) return 'red'
  return 'orange'
}
export const getCurrentS3Url = () => {
  const s3Url = getCookie('s3Url')
  if (s3Url) {
    return s3Url
  }
  return config.s3Url
}

export const isGifUrl = (url) => {
  return url && /\.gif$/.test(url)
}

export const validatePDFMIMEType = (file) => {
  if (!file) {
    return false
  }

  let mimeType = file.mime_type

  // Check if MIME type is a valid PDF MIME type
  if (mimeType === 'application/pdf') {
    return true
  } else {
    return false
  }
}

export const hasEmoji = (html) => {
  return emojiPattern.test(html)
}

export const checkTextAndEmoji = (html) => {
  if ((html.match(emojiPattern) || []).length > 4) {
    return 'emojiTextMessage'
  } else if (hasEmoji(html)) {
    const element = html.replace(emojiPattern, '')
    const tempElement = document.createElement('div')
    tempElement.innerHTML = element
    const content = tempElement.textContent.trim()
    if (content.length === 0) {
      return 'emojiMessage'
    } else {
      return ''
    }
  } else {
    return ''
  }
}

export const convertToPlain = (html) => {
  const tempDivElement = document.createElement('div')
  tempDivElement.innerHTML = html
  return tempDivElement.textContent || tempDivElement.innerText || ''
}

// Function to check and categorize matches
export const checkSharedText = (text) => {
  // Regex pattern to match text followed by a link or just a link
  const regex = /([^ ]+)(https?:\/\/[^\s]+)/g
  const match = text.match(regex)
  if (match) {
    const [, textPart, linkPart] = match
    if (textPart && linkPart) {
      return false
    } else {
      return true
    }
  } else {
    return false
  }
}

// this function is called to display draft message in disabled button on feed
export const htmlToText = (html) => {
  // Create a new DOMParser
  const parser = new DOMParser()
  // Parse the HTML content
  const parsedDocument = parser.parseFromString(html, 'text/html')
  // Extract text content from the parsed document
  const textContent = parsedDocument.body.textContent
  return textContent
}

export const formatNames = (names, includeLastname = false, t) => {
  if (names.length === 1) {
    const { firstname, lastname } = names[0]
    return `${firstname}${includeLastname ? ` ${lastname}` : ''}`
  }

  const formattedNames = names.map(({ firstname, lastname }) => `${firstname}${includeLastname ? ` ${lastname}` : ''}`)

  if (names.length === 2) {
    return formattedNames.join(` ${t('global.and')} `)
  }

  const [last, ...rest] = formattedNames.reverse()
  const namesList = rest.reverse().join(', ')

  return `${namesList}, ${t('global.and')} ${last}`
}

export const matchedSearchInterestsInArray = (interests, searchInterestText) => {
  if (interests?.length >= 1) {
    const regex = new RegExp(searchInterestText, 'gi')

    const similarMatches = interests.filter((interest) =>
      interest.name.toLowerCase().includes(searchInterestText.toLowerCase())
    )

    if (similarMatches.length > 0) {
      const matchWithHighLight = similarMatches[0].name.replace(
        regex,
        `<span class='highlighted' role="presentation">$&</span>`
      )
      return matchWithHighLight
    }
    // }
  }
}

export const getRatingEmojis = (t) => {
  return [
    { icon: 'smiley-upset', label: t('rating.ratingOption.notGood'), value: 1 },
    { icon: 'smiley-sad', label: t('rating.ratingOption.meh'), value: 2 },
    { icon: 'smiley-neutral', label: t('rating.ratingOption.good'), value: 3 },
    { icon: 'smiley-happy', label: t('rating.ratingOption.great'), value: 4 },
    { icon: 'smiley-glad', label: t('rating.ratingOption.amazing'), value: 5 }
  ]
}

export async function handleHardReload(url) {
  await fetch(url, {
    headers: {
      Pragma: 'no-cache',
      Expires: '-1',
      'Cache-Control': 'no-cache'
    }
  })
  window.location.href = url
  // This is to ensure reload with url's having '#'
  window.location.reload()
}

export const getDeviceId = () => {
  let deviceId = localStorage.getItem('device_id')
  if (!deviceId) {
    deviceId = generateUniqueId()
    localStorage.setItem('device_id', deviceId)
  }
  return deviceId
}

const generateUniqueId = () => {
  // Generate a unique identifier using the current timestamp and random numbers
  const timestamp = new Date().getTime()
  const randomNum = Math.floor(Math.random() * 1000000000)
  return `${timestamp}-${randomNum}`
}

export const sanitizeLinks = (htmlString) => {
  return htmlString?.replace(/<div[^>]*>(?:(?!<\/div>).)*?<a\b[^>]*href="[^"]*"[^>]*>.*?<\/a>(?:(?!<\/div>).)*?<\/div>/gi, '');
};

export const sanitizeMessengerLinks = (htmlString) => {
  if(isNativeIOS()) {
    return htmlString
  }
  return sanitizeLinks(htmlString)
};
